import { FC } from "react";
import { MuiModal } from "../../../../components/modal/MuiModal";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { MuiTypography } from "../../../../components/typography/MuiTypography";
import { programSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { SuccessFieldModalWrapper } from "./SuccessFieldModal.style";

interface SuccessFieldModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  handleOkButton: () => void;
}
export const SuccessFieldModal: FC<SuccessFieldModalProps> = ({
  handleModalClose,
  showModal,
  handleOkButton,
}) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  const getLabel = (key: string) => {
    return fetchLabel(programSiteCoreKeys.transferProcessPopup, key);
  };
  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={'Success'}
      primaryButtonTitle={commonLabels.ok}
      onPrimaryButtonClick={handleOkButton}
    >
      <SuccessFieldModalWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3Bold"
          className="confirm-message"
          data-testid="duration-warning-modal"
        >
          {getLabel(programSiteCoreKeys.versionCreatedMessage)}
        </MuiTypography>
        <MuiTypography
          id="modal-description"
          variant="h3"
          className="modal-lable-style"
          data-testid="duration-warning-modal"
        >
          {getLabel(programSiteCoreKeys.transferSucessText)}
        </MuiTypography>
      </SuccessFieldModalWrapper>
    </MuiModal>
  );
};
